import axios from 'axios'

// 创建 axios 实例
const api = axios.create({
  baseURL: 'https://publicity.cebpubservice.com/api',
  // baseURL: 'http://101.201.71.20:8600/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

// 新闻列表接口
export const getNewsList = (params) => {
  return api.get('/publicity/news/list', { params })
}

// 新闻详情接口
export const getNewsDetail = (id) => {
  return api.get(`/publicity/news/detail/${id}`)
}

// 报告查询接口
export const getReportList = (params) => {
  return api.get('/publicity/report/list', { params })
}

// 轮播图接口
export const getBannerList = (params) => {
  return api.get('/publicity/banner/list', { params })
}

export default api
